import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import LocationMap from '#component/form/location-map';

const RHFLocationMap = ({
  name,
  control,
  id,
  radius,
  measurementSystem,
  change,
  ...rest
}) => {
  const { setValue } = useFormContext() || {};

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <LocationMap
          id={id}
          input={{ value: Array.isArray(value) ? value : (value ? [value] : []), onChange }}
          change={change || setValue}
          radius={radius}
          measurementSystem={measurementSystem}
          {...rest}
        />
      )}
    />
  );
};

export default RHFLocationMap;
